import { register } from "@various/utils";

import Modal from "./default/index.vue";
import ModalSide from "./aside/index.vue";

export const UiModal = register.use(Modal, "component") as typeof Modal;
export const UiModalSide = register.use(ModalSide, "component") as typeof ModalSide;

export * from "./default";
export * from "./aside";

export default UiModal;
